import React, { useState, useEffect } from 'react'
import PageHeading from '../../components/PageHeading'
import { UserOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Input, message, 
  Table, Select, Tag,
  Popconfirm, Button
} from 'antd';
import { debounce } from 'lodash';
import axiosInstance from '../../utils/axios';

const Customer = () => {
  const [customers, setCustomers] = useState({
    page: 1,
    results: []
  });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(""); 
  const [search, setSearch] = useState('');

  useEffect(() => {
    const delayFetch = debounce(() => {
      fetchData();
    }, 550); // 550ms debounce

    delayFetch();
    
    return () => delayFetch.cancel();

    // eslint-disable-next-line
  }, [search, page, filter]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();

      params.append("page", page);
      params.append("search", search);
      if (filter !== "") params.append("is_active", filter);

      const response = await axiosInstance.get(`customer/manage/?${params.toString()}`);
      setCustomers(response.data);
    } catch (error) {
      message.error("Failed to fetch shows");
    } finally {
      setLoading(false);
    }
  };

  const cancel = () => message.info('Cancelled');

  const confirm = async (id, currentStatus) => {
    try {
        await axiosInstance.patch(`customer/manage/${id}/`, {
          'is_active': !currentStatus
        });
        message.success("updated successfully");
        fetchData();
    } catch (err) {
        message.error("Cannot update");
    }
  };

  const confirmDelete = async (id) => {
    try {
        await axiosInstance.delete(`customer/manage/${id}/`);
        message.success("deleted successfully");
        fetchData();
    } catch (err) {
        message.error("Cannot delete");
    }
  };


	const columns = [
		{
			title: 'Full Name',
			dataIndex: 'name',
			key: 'name',

		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
		},
	  {
			title: 'Mobile',
			dataIndex: 'mobile',
			key: 'mobile',
		},
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => 
        record.is_active === true ? <Tag color="#87d068">Active</Tag> : <Tag color="#f50">Blocked</Tag>      
      
    },
		{
			title: 'Action',
			dataIndex: '',
			key: 'actions',
			render: (_, record) => (
				<>
            <Popconfirm
                title="Change Status"
                description="Are you sure want to change user's status?"
                onConfirm={() => confirm(record.id, record.is_active)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
            >
                <Button type="link" info icon={<EditOutlined />} />
            </Popconfirm>
            <Popconfirm
              title="Delete"
              description="Are you sure want to delete user?"
              onConfirm={() => confirmDelete(record.id)}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
                <Button type="link" danger icon={<DeleteOutlined />} />
            </Popconfirm>
				</>
			)
		},
	];


  return (
		<div className='dashboard'>
			<PageHeading name="Customer" icon={<UserOutlined/>} />
      <div style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: 16
			}}>
        <Input
          placeholder="Search here"
          prefix={<SearchOutlined />}
          style={{ width: "190px" }}
          onChange={(e) => setSearch(e.target.value)}
        />
				<Select
					placeholder="Filter by users"
					allowClear
					style={{ width: 200 }}
					onChange={(value) => {
						setPage(1);  
						setFilter(value);
					}}
				>
					<Select.Option value="">All</Select.Option>
					<Select.Option value={true}>Active Users</Select.Option>
					<Select.Option value={false}>Blocked Users</Select.Option>
				</Select>
			</div>
      <Table
        dataSource={customers.results}
        loading={loading}
        columns={columns}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        pagination={{
          current: page,
          pageSize: 20,
          total: customers.count,
          onChange: (newPage, _) => {
            setPage(newPage);
          }
        }}
      />
    </div>
  )
}

export default Customer